import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (refresh) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: '/api/Work/shop',
    name: 'workshopInformationGet',
    method: 'GET'
  });
  useEffect(() => {
    if (refresh) {
      exec({ url: '/api/Work/shop' })
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);
  return [isRequestSuccessed, data || [], exec];
})
